import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/voting/[slug]/CollectionWrapper.tsx");
